// extracted by mini-css-extract-plugin
export default {"Network":"Network_Network__ibs44","NetworkBG":"Network_NetworkBG__RMViu","Text":"Network_Text__AM7+G","Desc":"Network_Desc__nrFjI"};